import styled from 'styled-components';

interface ContainerProps {
  $activeKey: string;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 900px;
  height: 100%;
  position: relative;

  .minimized-modal {
    position: absolute;
  }

  .ant-tabs {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 0
      ${({ $activeKey, theme: { token } }) => ($activeKey === 'control-center' ? token.paddingXL : token.padding)}px;
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
    overflow: hidden;

    .ant-tabs-nav {
      .ant-tabs-nav-wrap {
        display: flex;
        justify-content: center;

        .ant-tabs-tab {
          padding-left: ${({ theme: { token } }) => token.paddingXS}px;
          padding-right: ${({ theme: { token } }) => token.paddingXS}px;
          margin-left: ${({ theme: { token } }) => token.marginSM}px;
          margin-right: ${({ theme: { token } }) => token.marginSM}px;
          flex-grow: 0;
        }

        .ant-tabs-ink-bar {
          height: 3px;
          border-radius: 5px 5px 0px 0px;
        }
      }
    }

    .ant-tabs-content-holder {
      display: flex;
      flex-direction: column;

      .ant-tabs-content {
        flex-grow: 1;
        flex-shrink: 0;
        height: 100%;

        .ant-tabs-tabpane-active {
          overflow: ${({ $activeKey }) =>
            $activeKey === 'control-center' ? 'auto' : $activeKey === 'map' ? 'initial' : 'scroll'};
        }

        .ant-tabs-tabpane {
          height: 100%;

          .tab-map {
            display: flex;
            flex-direction: column;
            height: 100%;

            .low-opacity-cover {
              opacity: 0.8;
              width: 100%;
              height: 100%;
              background-color: ${({ theme: { token } }) => token.colorBgBase};
              z-index: 2;
              position: absolute;
            }

            .background-data-label {
              z-index: 2;
              position: absolute;
              bottom: 10px;
              right: 0;
              color: ${({ theme: { token } }) => token.colorBorder};
              font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
              font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
            }

            .map-kpi-container {
              display: flex;
              justify-content: center;
              height: 140px;
              text-align: center;
              flex-shrink: 0;
              margin-top: ${({ theme: { token } }) => token.marginXL}px;
              margin-bottom: ${({ theme: { token } }) => token.marginXS}px;

              &.collapsed {
                margin-top: -${({ theme: { token } }) => token.marginXS}px;
                height: 80px;
              }

              .centerer {
                flex-basis: 1000px;
                flex-shrink: 1;
              }
            }

            .map-builder-container {
              flex-grow: 1;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .minimized-modal-container {
    margin-left: -${({ theme: { token } }) => token.padding}px;
    margin-right: -${({ theme: { token } }) => token.padding}px;
    box-shadow: ${({ theme: { token } }) => token.boxShadowDrawerDown};
    border-left: 1px solid ${({ theme: { token } }) => token.colorBgLayout};
  }
`;
